import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field } from '@simonbackx/simple-encoding';
export class WebshopUriAvailabilityResponse extends AutoEncoder {
    available;
}
__decorate([
    field({ decoder: BooleanDecoder })
], WebshopUriAvailabilityResponse.prototype, "available", void 0);
//# sourceMappingURL=WebshopUriAvailabilityResponse.js.map